// WP.Gutenberg.Vidda.WPBlock
import { List } from 'immutable'
import { AsyncState, unloadedAsyncState } from 'widgets-for-react'
import { Drupal } from './drupal/api'
import { DP } from './drupal/blockDefinitions'
import { ImageSizesProps, ImageSourcesProps, ModernBlock, ModernBlocksState } from './modernBlocks/modernBlocks.state'
import { Link } from './utils/link'
import { WordPress } from './wordpress/api'
import * as WP from './wordpress/blockDefinitions'
import { LinkGridItemProps } from './modernBlocks/blocks/gridBlock/gridBlock.state'

// const environment: keyof ModernBlock<any, any, any, any>["adapters"] = "drupal"

export type CMSEnvironment = {
  environment: keyof ModernBlock<any, any, any, any>['adapters']
}

export type Breadcrumbs = List<{ url: string; title: string }>

export type PageHeader = {
  kind: 'normal' | 'fullscreen'
  pageTitle: string
  pageIntro: string
  hideDonationButton: boolean
  linkPrimary: Link | undefined
  linkSecondary: Link | undefined
  publishDate?: Date,
  videoUrl?: string
  imageSize: 'small' | 'large'
  imageSource?: ImageSourcesProps['sources']
} & ImageSizesProps

export type HomeHeader = {
  kind: "home"
  pageTitle: string
  pageIntro?: string
  linkPrimary: Link | undefined
  linkSecondary: Link | undefined
  hideDonationButton: boolean
  grid?: LinkGridItemProps[]
} & ImageSizesProps

export type PageData = {
  header: HomeHeader | PageHeader,
  page: {
    kind: string
    header: string
    node: any
    language: string
    nodeId: string
  }
  metadata: {
    title?: string
  }
  tableOfContents: boolean
  breadcrumbs: Breadcrumbs
}

export type CMSLoaderState = {
  blocks: WP.Gutenberg.Vidda.WPBlock[] | DP.DPBlock[]
  pageData: PageData
}

export type CMSBlocksState = {
  loader: AsyncState<CMSLoaderState>
  modernBlocks: ModernBlocksState
}

export type CMSLanguageMenuItem = {
  HomeUrl: string
  Language: string
}

export type CMSMenuItem = {
  PageId: number
  Title: string
  Description?: string
  Url: string
  Weight: number
  Children: Omit<CMSMenuItem, 'Children'>[]
  ShowChildren: boolean
}

export type CMSFooterItem = CMSMenuItem & {
  Column: string
}

export const initCMSBlocksState = (cmsEnvironment: CMSEnvironment['environment']): CMSBlocksState => ({
  loader: unloadedAsyncState(),
  modernBlocks: {
    blocks: List(),
    environment: cmsEnvironment,
    // environment: "drupal"
  },
})

export const loadCMSBlocksState = (cmsEnvironment: CMSEnvironment['environment'], slug: string): CMSBlocksState => {
  // console.error(cmsEnvironment)
  return {
    loader:
      cmsEnvironment == 'wordpress'
        ? WordPress.loadPage(slug)
        : slug == ''
        ? Drupal.loadHomePage(slug)
        : Drupal.loadPage(slug),
    // loader: Drupal.loadPage('kevin'),
    modernBlocks: {
      blocks: List(),
      environment: cmsEnvironment,
      // environment: "drupal"
    },
  }
}

export const loadPreviewBlockState = (cmsEnvironment: CMSEnvironment['environment'], nodeId: number, revisionId: string, previewToken: string): CMSBlocksState  => {
  return {
    loader: Drupal.loadPreviewPage(nodeId, revisionId, previewToken),
    modernBlocks: {
      blocks: List(),
      environment: cmsEnvironment
    }
  }}

// export const updateCookiebarState =
//   (u: Updater<CookiebarState>): Updater<State> =>
//   (s) => {
//     let s1 = { ...s, cookiebarState: u(s.cookiebarState) }
//     return s1
//   }

